<template>
  <div class="md:justify-end flex flex-col items-center w-full h-full mb-4">
    <div
      class="md:overflow-hidden flex items-center justify-center flex-auto w-full my-auto"
    >
      <div class="flex flex-col items-center flex-auto max-h-full my-auto">
        <div class="md:overflow-hidden flex-auto w-full my-auto">
          <slot :navigate="navigate" />
        </div>
      </div>
    </div>
    <tabs-group
      class="mt-4"
      :items="subpages"
      :action="changeTab"
      center-active
      show-arrows="always"
      ref="nav"
    />
  </div>
</template>

<script>
import _ from "lodash";
import { matchedRouteKey } from "vue-router";
import TabsGroup from "@/components/nav/TabsGroup";

export default {
  inject: [matchedRouteKey],
  components: { TabsGroup },
  computed: {
    navRoute() {
      return this[matchedRouteKey].value;
    },
    subpages() {
      const subPages = _.sortBy(this.navRoute.children, [
        i => {
          return i.meta.tabOrder;
        }
      ]);
      console.log(subPages);
      console.log(this.navRoute);
      return subPages;
    }
  },
  methods: {
    changeTab(page) {
      this.$router.push({ name: page.name });
    },
    getAdjacentRoute(direction) {
      const nextTabNumber =
        this.$route.meta.tabOrder + direction > this.subpages.length
          ? 1
          : this.$route.meta.tabOrder + direction < 1
          ? this.subpages.length
          : this.$route.meta.tabOrder + direction;

      const route = _.find(this.subpages, r => {
        return r.meta && r.meta.tabOrder === nextTabNumber;
      });

      return route;
    },
    navigate(direction) {
      const page = this.getAdjacentRoute(direction);
      page && this.changeTab(page);
      page && this.$refs.nav.setFromRoute(page.name);
    }
  }
};
</script>
